module.exports = __webpack_public_path__ + "img/imgUpdate.59ff6f15.png";